import * as React from 'react';
import { SVGProps } from 'react';
const Bot = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		xmlSpace="preserve"
		viewBox="0 0 122.88 105.21"
		{...props}
	>
		<path
			d="M63.91 18.75v12.16h33.51c5.43 0 9.87 4.44 9.87 9.87v12.47h13.42c1.19 0 2.17.97 2.17 2.17V80.7c0 1.19-.97 2.17-2.17 2.17h-13.42v12.47c0 5.43-4.44 9.87-9.87 9.87h-73c-5.43 0-9.87-4.44-9.87-9.87V82.87H2.17C.97 82.87 0 81.9 0 80.71V55.42c0-1.19.97-2.17 2.17-2.17h12.38V40.79c0-5.43 4.44-9.87 9.87-9.87h33.51V18.75a9.608 9.608 0 0 1-6.62-9.14c0-5.31 4.3-9.61 9.61-9.61s9.61 4.3 9.61 9.61c0 4.27-2.78 7.88-6.62 9.14zM41.03 79.74h40.81c1.99 0 3.62 1.63 3.62 3.62v1.7c0 1.99-1.63 3.62-3.62 3.62H41.03c-1.99 0-3.62-1.63-3.62-3.62v-1.7c0-2 1.63-3.62 3.62-3.62zM78.7 47.59c5.37 0 9.73 4.35 9.73 9.73 0 5.37-4.35 9.72-9.73 9.72s-9.72-4.35-9.72-9.72c-.01-5.38 4.35-9.73 9.72-9.73zm-34.52 0c5.37 0 9.72 4.35 9.72 9.73 0 5.37-4.35 9.72-9.72 9.72-5.37 0-9.72-4.35-9.72-9.72 0-5.38 4.35-9.73 9.72-9.73z"
			style={{
				fillRule: 'evenodd',
				clipRule: 'evenodd',
			}}
		/>
	</svg>
);
export default Bot;
